import {
  PRODUCT_PRO_LNGLIST_MODAL_CHANGE,
} from './constants';

export function pro_lnglistModalChange(visible,type) {
  return {
    type: PRODUCT_PRO_LNGLIST_MODAL_CHANGE,
    data: {visible,type},
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PRODUCT_PRO_LNGLIST_MODAL_CHANGE:
      return {
        ...state,
        pro_lnglistModalType:action.data.type,
        pro_lnglistModalVisible:action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/product/redux/pro_lnglistModalChange.js